import { tv, type VariantProps } from 'tailwind-variants'
import { Title } from '_/ui/title'
import { InfoContainer } from '_/ui/sections-trip/info-container'
import { Profile } from './profile'
import { type TripType } from '_/services/trips/get-trip.schema'
import { calculateAdulthood, convertDateFormat } from '_/utils/date'
import React from 'react'

const styles = tv({
	slots: {
		base: 'w-full',
		title: 'text-primary-neutral mb-4',
		table: 'w-full',
		th: 'text-sm font-normal text-gray-500 text-left',
		td: 'text-gray-700 font-bold',
		thead: 'align-baseline h-7.5',
		trBody:
			'h-14 align-middle border-b border-primary-light last-of-type:border-0 last-of-type:h-10 last-of-type:align-bottom',
	},
})

interface ChartDesktopProps extends VariantProps<typeof styles> {
	className?: string
	trip: TripType
}

const { base, th, td, table, thead, trBody, title } = styles()

export const ChartDesktop = ({ className, trip, ...rest }: ChartDesktopProps) => {
	const { rooms } = trip
	const roomGuests = rooms.map((room, index) => ({
		roomNumber: room.number,
		guests: room.guests,
		roomId: room.id,
		id: index,
	}))

	const initialDate = trip.initialDate || trip.expectedInitialDate || null

	return (
		<div {...rest} className={base({ class: className })}>
			<Title size='small' className={title()} asChild>
				<h3>Guests</h3>
			</Title>
			<InfoContainer>
				<table className={table()}>
					<thead className={thead()}>
						<tr>
							<th className={`${th()} w-[41%]`}>Name</th>
							<th className={`${th()} w-[23%]`}>Age Group</th>
							<th className={`${th()} w-[23%]`}>Date of birth</th>
							<th className={`${th()} w-[27%]`}>Room</th>
						</tr>
					</thead>
					<tbody>
						{roomGuests.map(roomGuest => (
							<React.Fragment key={roomGuest.id}>
								{roomGuest.guests.map(guest => (
									<tr className={`${trBody()} ${guest.id}`} key={guest.id}>
										<td className={td()}>
											<Profile nameData={`${guest.firstName}${' '}${guest.lastName}`} />
										</td>
										<td className={td()}>
											{guest.birthday
												? calculateAdulthood(guest.birthday as unknown as Date, initialDate as unknown as Date)
												: '-'}
										</td>
										<td className={td()}>{guest.birthday ? convertDateFormat(guest.birthday, 'MM/DD/YYYY') : '-'}</td>
										<td className={td()}>{roomGuest.id + 1}</td>
									</tr>
								))}
							</React.Fragment>
						))}
					</tbody>
				</table>
			</InfoContainer>
		</div>
	)
}
